import React, { useEffect } from "react";
import InfoWindow from "./InfoWindow";
import useCommonMap from "../../hooks/useCommonMap";

const InfoWindows = ({
  groups,
  nearbyItems,
  // updateInfoWindows,
  // setUpdateInfoWindows,
}) => {
  const { showAllLabelsToggle } = useCommonMap();

  useEffect(() => {
    groups.forEach((element) => {
      element.showInfo = showAllLabelsToggle;
    });
  }, [showAllLabelsToggle]);

  const clickTarget = (e) => {};

  const onClose = (e, item) => {
    item.showInfo = false;
  };

  // if (updateInfoWindows === true) {
  //   setUpdateInfoWindows(false);
  // }

  return (
    <React.Fragment>
      {groups &&
        groups
          .values()
          .toArray()
          .map((group) => {
            // console.log("%s", JSON.stringify(group["ids"]));
            if (group.showInfo === true && group.marker && group.marker.item) {
              const marker = group.marker;
              return (
                <InfoWindow
                  key={`${marker.item.id}`}
                  clickTarget={clickTarget}
                  marker={marker}
                  item={{
                    lastPosition: marker.item,
                    type: marker.item.type,
                  }}
                  onClose={(e) => onClose(e, group)}
                />
              );
            }
            return null;
          })}
    </React.Fragment>
  );
};

export default InfoWindows;
